import { faDiscord } from "@fortawesome/free-brands-svg-icons";
import { faEnvelope } from "@fortawesome/free-regular-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import StakesComponent from "components/common/stakes/stakesComponent";
import React from "react";
import { Modal } from "react-bootstrap";
import { useSelector } from "react-redux";

const closeButton = require("../../../images/definitive/btn-close.svg");

export default function StakeModal({ show, hide }) {
    const configs = useSelector(state => state.config);

    return (
        <Modal show={show} onHide={hide} size="lg">
            <Modal.Body className="stake-modal">
                <div className='stake-header'>
                    <div className='stake-close' onClick={hide}>
                        <img src={closeButton} alt={"Close Modal"} />
                    </div>
                    <h3>
                        Submission Received!
                    </h3>
                </div>
                <div className="text-center">
                    <div className="stake-text-1">
                        Your game's request to go public has been received and is currently
                        being reviewed by the QUDO team.
                    </div>

                    <div className="stake-text-2">
                        To make your game publicly available, you'll need to stake a
                        minimum amount of QUDO.
                    </div>
                </div>
                <div>
                    <StakesComponent minimumStakeValue={configs ? configs.stake_per_game : null} />
                </div>
                <div className="text-center">
                    <h4>
                        Dont have QUDO yet?
                    </h4>
                    <span className="stake-text-2">
                        You'll be able to get it from the following exchanges:
                    </span>
                    <div className="stake-exchanges">
                        <span>Coming Soon</span>
                        <span>Coming Soon</span>
                    </div>

                    <div className="stake-help">
                        <div className="stake-text-1">
                            Need assistance? Contact Us
                        </div>
                        <span className="stake-text-2">
                            <a
                                target="_blank"
                                rel="noopener noreferrer"
                                href="https://discord.com/invite/SwmdFkMhhe"
                                className="social-media-icon"
                                style={{ color: '#7289da' }}
                            >
                                <FontAwesomeIcon icon={faDiscord} />
                            </a>
                            <a
                                target="_blank"
                                rel="noopener noreferrer"
                                href="mailto:qudo.support@blockbastards.io"
                                className="social-media-icon"
                                style={{ color: '#5e5e5e' }}
                            >
                                <FontAwesomeIcon icon={faEnvelope} />
                            </a>
                        </span>
                    </div>
                </div>
            </Modal.Body>
        </Modal>
    );
}
